<!-- One profile avatar: the CLASSIC default avatar, a CIRCLE (corners stay
     transparent, the export is round too) holding a vertical token gradient
     (windowBackground -> editorBackground). PERSON: one figure in circle
     green. GROUP: the classic depth pair in circle blue, a big figure front
     left, a smaller one behind right, separated by a background-coloured gap
     (the back figure is masked out around the front one's outline). -->
<svg class="lp-tile" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid slice"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient [attr.id]="uid + '-bg'" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" [attr.stop-color]="bgTop"></stop>
      <stop offset="1" [attr.stop-color]="bgBot"></stop>
    </linearGradient>
    <clipPath [attr.id]="uid + '-clip'">
      <circle cx="60" cy="60" r="60"></circle>
    </clipPath>
    <!-- Punches the gap around the FRONT figure out of the BACK figure. -->
    <mask [attr.id]="uid + '-backm'">
      <rect x="0" y="0" width="120" height="120" fill="#ffffff"></rect>
      <circle cx="42" cy="52" r="24" fill="#000000"></circle>
      <path d="M-3,120 C-3,87 15,73 42,73 C69,73 87,87 87,120 Z" fill="#000000"></path>
    </mask>
  </defs>

  <g [attr.clip-path]="'url(#' + uid + '-clip)'">
    <rect x="0" y="0" width="120" height="120" [attr.fill]="'url(#' + uid + '-bg)'"></rect>

    <!-- ============ PERSON: the group's front figure, centred ============ -->
    <g *ngIf="kind === 'person'" [attr.fill]="fig">
      <circle cx="60" cy="50" r="19"></circle>
      <path d="M20,120 C20,90 36,76 60,76 C84,76 100,90 100,120 Z"></path>
    </g>

    <!-- ============ GROUP (depth pair, wide easy shoulders) ============ -->
    <g *ngIf="kind === 'group'" [attr.fill]="fig">
      <g [attr.mask]="'url(#' + uid + '-backm)'">
        <circle cx="82" cy="38" r="16"></circle>
        <path d="M48,120 C48,82 62,66 85,66 C108,66 122,82 122,120 Z"></path>
      </g>
      <circle cx="42" cy="52" r="19"></circle>
      <path d="M2,120 C2,92 18,78 42,78 C66,78 82,92 82,120 Z"></path>
    </g>
  </g>
</svg>
